<nav id="sidebarMenu" class="sidebar" [class.sidebar-collapsed]="isSidebarCollapsed()"
    [class.show]="!isSidebarCollapsed()">
    <!-- Logo Header -->
    <div class="sidebar-header d-flex align-items-center justify-content-center p-3">
        <a class="navbar-brand" [class.collapsed-logo]="isSidebarCollapsed()"
            [routerLink]="['/dashboard']"
            [msTooltip]="'Dashboard'"
            [msTooltipPlacement]="TooltipPlacement.Bottom">
            <div class="logo-container">
                <!-- Full logo - shown when expanded or when hovering collapsed sidebar -->
                @if ((isDarkThemeActive$ | async)) {
                    <img alt="Logo" src="/ms/images/logos/HOAStart-Logo-dark.svg" class="sidebar-logo" />
                } @else {
                    <img alt="Logo" src="/ms/images/logos/HOAStart-Logo.svg" class="sidebar-logo" />
                }
                <!-- Small logo - shown when collapsed and not hovering -->
                <img alt="Logo" src="/ms/images/logos/HOAStart-Logo-Small.png" class="sidebar-logo-small" />
            </div>
        </a>
    </div>

    <ms-organization-switcher></ms-organization-switcher>

    <!-- Scrollable Navigation Container -->
    <div class="sidebar-nav-container">
        <ul class="nav flex-column">

            <!-- Dashboard -->
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/dashboard']" routerLinkActive="active" title="Dashboard">
                    <fa-duotone-icon icon="home"/>
                    <span class="nav-text">Dashboard</span>
                </a>
            </li>

            <!-- Staff Functions -->
            <li class="nav-item" *isStaff>
                <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#staffFunctionsSubmenu"
                    aria-expanded="false">
                    <fa-duotone-icon icon="gear"/>
                    <span class="nav-text">Staff Functions</span>
                    <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                </a>
                <div class="collapse" id="staffFunctionsSubmenu" routerLinkActive="show" [routerLinkActiveOptions]="{exact: false}">
                    <ul class="nav flex-column pt-0">
                        <li class="nav-item" *ifHasPermission="{requiredPermissions: [OrganizationPermission.Read], userPermissionOnly: true, dataEntityType: DataEntityTypes.User}">
                            <a class="nav-link sub-nav-link" [routerLink]="['/organizations']" [routerLinkActive]="['active']" >
                                <span class="nav-text">Organizations</span>
                            </a>
                        </li>
                        <li class="nav-item" *ifHasPermission="{requiredPermissions: [UserPermission.Read], userPermissionOnly: true, dataEntityType: DataEntityTypes.User}">
                            <a class="nav-link sub-nav-link" [routerLink]="['/users']" [routerLinkActive]="['active']" target="_self">
                                <span class="nav-text">Users</span>
                            </a>
                        </li>
                        <li class="nav-item" *ifHasPermission="{requiredPermissions: staffManagementPermissions, userPermissionOnly: true, dataEntityType: DataEntityTypes.User}">
                            <a class="nav-link sub-nav-link" [routerLink]="['/staff-management']" [routerLinkActive]="['active']" target="_self">
                                <span class="nav-text">Staff Management</span>
                            </a>
                        </li>
                        <li class="nav-item" *ifHasPermission="{requiredPermissions: [FeatureFlagPermission.Read], userPermissionOnly: true, dataEntityType: DataEntityTypes.User}">
                            <a class="nav-link sub-nav-link" [routerLink]="['/feature-flags']" [routerLinkActive]="['active']">
                                <span class="nav-text">Feature Flags</span>
                            </a>
                        </li>
                        <!-- Unwired items - commented out as part of DEV-2333 cleanup pass
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Assignments</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Pricing</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Onboarding</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Support Tickets</span>
                            </a>
                        </li>
                        -->
                    </ul>
                </div>
            </li>

            @if (userSessionService.activeOrganization()) {
                <!-- Members -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [MemberPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.Member}">
                    <a class="nav-link" [routerLink]="['/members']" routerLinkActive="active" title="Members">
                        <fa-duotone-icon icon="user"/>
                        <span class="nav-text">Members</span>
                    </a>
                </li>

                <!-- Member Directory (ungated: Members hold no permissions, and they are who it is for) -->
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/member-directory']" routerLinkActive="active" title="Member Directory">
                        <fa-duotone-icon icon="address-book"/>
                        <span class="nav-text">Member Directory</span>
                    </a>
                </li>

                <!-- Properties -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [PropertyPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                    <a class="nav-link" [routerLink]="['/properties']" routerLinkActive="active" title="Properties">
                        <fa-duotone-icon icon="home"/>
                        <span class="nav-text">Properties</span>
                    </a>
                </li>

                <!-- Import -->
                <ng-container *ifFeatureEnabled="FeatureFlag.MemberPropertyImport">
                    <li class="nav-item" *ifHasPermission="{requiredPermissions: [ImportPermission.Manage], userPermissionOnly: false}">
                        <a class="nav-link" [routerLink]="['/import']" routerLinkActive="active" title="Import">
                            <fa-duotone-icon icon="file-import"/>
                            <span class="nav-text">Import</span>
                        </a>
                    </li>
                </ng-container>

                <!-- Document Center (promoted from Features dropdown - POC: shown to everyone in an org. Add *ifHasPermission once documents.* roles exist.) -->
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/documents']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" title="Document Center">
                        <fa-duotone-icon icon="folder-open"/>
                        <span class="nav-text">Document Center</span>
                    </a>
                </li>

                <!-- Message Center -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [MessagePermission.Read, MessagePermission.Send], userPermissionOnly: false, dataEntityType: DataEntityTypes.Message}">
                    <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#messageCenterSubmenu"
                        aria-expanded="false">
                        <fa-duotone-icon icon="envelope"/>
                        <span class="nav-text">Message Center</span>
                        <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                    </a>
                    <div class="collapse" id="messageCenterSubmenu" routerLinkActive="show" [routerLinkActiveOptions]="{exact: false}">
                        <ul class="nav flex-column">
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [MessagePermission.Send], userPermissionOnly: false, dataEntityType: DataEntityTypes.Message}">
                                <a class="nav-link sub-nav-link" [routerLink]="['send-email']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Send Email</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [MessagePermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.Message}">
                                <a class="nav-link sub-nav-link" [routerLink]="['sent-emails']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Email History</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

                <!-- Balances -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [BalancesPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                    <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#balancesSubmenu"
                        aria-expanded="false">
                        <fa-duotone-icon icon="dollar-sign"/>
                        <span class="nav-text">Balances</span>
                        <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                    </a>
                    <div class="collapse" id="balancesSubmenu" routerLinkActive="show" [routerLinkActiveOptions]="{exact: false}">
                        <ul class="nav flex-column">
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [BalancesPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['invoices/dashboard']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Invoice Dashboard</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [BalancesPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['invoice-schedules']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Invoice Schedules</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [PaymentsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['payment-dashboard']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Payment Dashboard</span>
                                </a>
                            </li>
                            <!-- Unwired items - commented out as part of DEV-2333 cleanup pass
                            <li class="nav-item disabled">
                                <a class="nav-link sub-nav-link" >
                                    <span class="nav-text">Credits</span>
                                </a>
                            </li>
                            -->
                        </ul>
                    </div>
                </li>

                <!-- Financials -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [FinancialsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                    <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#financialsSubmenu"
                        aria-expanded="false">
                        <fa-duotone-icon icon="university"/>
                        <span class="nav-text">Financials</span>
                        <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                    </a>
                    <div class="collapse" id="financialsSubmenu">
                        <ul class="nav flex-column">
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [FinancialsPermission.CreateLedgerEntry], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['manual-gl-entries']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Manual GL Entries</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [FinancialsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['expenses']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Expenses</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [FinancialsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['budgets']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Budgets</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [FinancialsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['reports']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Reports</span>
                                </a>
                            </li>
                            <li class="nav-item" *ifHasPermission="{requiredPermissions: [ChartOfAccountsPermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                <a class="nav-link sub-nav-link" [routerLink]="['chart-of-accounts']" [routerLinkActive]="['active']">
                                    <span class="nav-text">Chart of Accounts</span>
                                </a>
                            </li>
                            <ng-container *ifFeatureEnabled="FeatureFlag.BankReconciliation">
                                <li class="nav-item" *ifHasPermission="{requiredPermissions: [StripePermission.Read], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
                                    <a class="nav-link sub-nav-link" [routerLink]="['bank-reconciliation']" [routerLinkActive]="['active']">
                                        <span class="nav-text">Bank Reconciliation</span>
                                    </a>
                                </li>
                            </ng-container>
                            <!-- Unwired items - commented out as part of DEV-2333 cleanup pass
                            <li class="nav-item disabled">
                                <a class="nav-link sub-nav-link" >
                                    <span class="nav-text">Accounts Receivable</span>
                                </a>
                            </li>
                            <li class="nav-item disabled">
                                <a class="nav-link sub-nav-link" >
                                    <span class="nav-text">Accounts Payable</span>
                                </a>
                            </li>
                            <li class="nav-item disabled">
                                <a class="nav-link sub-nav-link" >
                                    <span class="nav-text">Vendors</span>
                                </a>
                            </li>
                            -->
                        </ul>
                    </div>
                </li>

                <!-- Organization Settings -->
                <li class="nav-item">
                    <a class="nav-link"
                        [routerLink]="['/organizations/profile', userSessionService.activeOrganization()?.organizationId]"
                        [queryParams]="{ tab: OrganizationProfileNavItems.Settings }"
                        routerLinkActive="active" title="Organization Settings">
                        <fa-duotone-icon icon="building"/>
                        <span class="nav-text">Organization Settings</span>
                    </a>
                </li>

                <!-- Support -->
                <li class="nav-item" *ifHasPermission="{requiredPermissions: [SupportPermission.CreateTicket], userPermissionOnly: false}">
                    <a class="nav-link" [routerLink]="['/support']" routerLinkActive="active" title="Support">
                        <fa-duotone-icon icon="info-circle"/>
                        <span class="nav-text">Support</span>
                    </a>
                </li>
            }

            <!-- Unwired sections - commented out as part of DEV-2333 cleanup pass.
                 Document Center was the only wired piece of the Features dropdown and has been
                 promoted to a top-level item above.

            <li class="nav-item">
                <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#featuresSubmenu"
                    aria-expanded="false">
                    <fa-duotone-icon icon="star"/>
                    <span class="nav-text">Features</span>
                    <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                </a>
                <div class="collapse" id="featuresSubmenu">
                    <ul class="nav flex-column">
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Calendars</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Sponsors</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Events</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Amenities</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Voting</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Ticketing</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Violations</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Forms</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="nav-item">
                <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#communicationsSubmenu"
                    aria-expanded="false">
                    <fa-duotone-icon icon="comments"/>
                    <span class="nav-text">Communications</span>
                    <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                </a>
                <div class="collapse" id="communicationsSubmenu">
                    <ul class="nav flex-column">
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Inbox</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Email</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Text Messages</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">History</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Templates</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="nav-item">
                <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#manageSiteSubmenu"
                    aria-expanded="false">
                    <fa-duotone-icon icon="cog"/>
                    <span class="nav-text">Manage Site</span>
                    <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                </a>
                <div class="collapse" id="manageSiteSubmenu">
                    <ul class="nav flex-column">
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Site Setup</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Portal App Setup</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="nav-item">
                <a class="nav-link collapsed"  data-bs-toggle="collapse" data-bs-target="#supportSubmenu"
                    aria-expanded="false">
                    <fa-duotone-icon icon="info-circle"/>
                    <span class="nav-text">Support</span>
                    <fa-duotone-icon icon="chevron-down" secondaryOpacity="0.9" class="ms-auto me-0 expand"/>
                </a>
                <div class="collapse" id="supportSubmenu">
                    <ul class="nav flex-column">
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Support Desk</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Help Resources</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Onboarding</span>
                            </a>
                        </li>
                        <li class="nav-item disabled">
                            <a class="nav-link sub-nav-link" >
                                <span class="nav-text">Changelog</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="nav-item disabled">
                <a class="nav-link" >
                    <fa-duotone-icon icon="plus-circle"/>
                    <span class="nav-text">Additional Services</span>
                </a>
            </li>

            <li class="nav-item disabled">
                <a class="nav-link" >
                    <fa-duotone-icon icon="globe"/>
                    <span class="nav-text">Public Site</span>
                </a>
            </li>
            -->

        </ul>
    </div>
</nav>
